import {
  getRequiredEdsLimitationsScope,
  getRequiredEdsLimitationsVersion
} from '@/global/environmentGetters'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { ClinicalScoreResultDtoErrorCodeEnum, type ClinicalScoreResultDto } from '@/generated'

export function useEdsPlugin() {
  const { t } = useI18n()

  const { latestEdsAcceptance } = storeToRefs(useUserStore())

  const REQUIRED_EDS_LIMITATIONS_VERSION = getRequiredEdsLimitationsVersion()
  const REQUIRED_EDS_LIMITATIONS_SCOPE = getRequiredEdsLimitationsScope()

  const hasAcceptedEdsLimitation = computed(() => {
    return latestEdsAcceptance.value?.version === REQUIRED_EDS_LIMITATIONS_VERSION
  })

  const getEdsScoreTooltipText = (edsScore?: ClinicalScoreResultDto): string => {
    if (edsScore?.errorCode === ClinicalScoreResultDtoErrorCodeEnum.WARD_EXCLUDED) {
      return t('Score is not applicable for this ward')
    }

    if (!edsScore || edsScore.scoreValue == null || edsScore.scoreTimestamp == null) {
      return t('No current data available')
    }

    const MS_PER_MINUTE = 1000 * 60
    const MS_PER_HOUR = MS_PER_MINUTE * 60

    const diffMs = Math.max(0, Date.now() - new Date(edsScore.scoreTimestamp).getTime())
    const hours = Math.floor(diffMs / MS_PER_HOUR)
    const minutes = Math.floor((diffMs % MS_PER_HOUR) / MS_PER_MINUTE)

    return t('Last updated {hours} hrs {minutes} mins ago', { hours, minutes })
  }

  return {
    hasAcceptedEdsLimitation,
    REQUIRED_EDS_LIMITATIONS_VERSION,
    REQUIRED_EDS_LIMITATIONS_SCOPE,
    getEdsScoreTooltipText
  }
}
